import { contractHttpRequest } from '@utils';

import { RESIGNATION_PAGE_SIZE } from './types';

export const RESIGNATION_API_PATHS = Object.freeze({
  config: '/client/h5/resignation/config',
  create: '/client/h5/resignation/applications',
  page: '/client/h5/resignation/applications/page',
});

export const fetchH5ResignationConfig = () => contractHttpRequest.get(
  RESIGNATION_API_PATHS.config,
);

const trimValue = (value) => (typeof value === 'string' ? value.trim() : value || '');

const normalizeRequestedResignDate = (value) => {
  if (!value) return value;

  if (typeof value.clone === 'function' && typeof value.startOf === 'function') {
    return value.clone().startOf('day').valueOf();
  }

  if (value instanceof Date) {
    const normalized = new Date(value);
    normalized.setHours(0, 0, 0, 0);
    return normalized.getTime();
  }

  return value;
};

export const buildResignationApplicationPayload = ({
  requestedResignDate,
  requestedReason,
  remark,
} = {}) => ({
  requestedResignDate: normalizeRequestedResignDate(requestedResignDate),
  requestedReason: trimValue(requestedReason),
  remark: trimValue(remark),
});

export const fetchResignationApplications = ({
  status,
  pageNumber = 0,
  pageSize = RESIGNATION_PAGE_SIZE,
} = {}) => contractHttpRequest.post(
  RESIGNATION_API_PATHS.page,
  {
    ...(status ? { status } : {}),
    pageNumber,
    pageSize,
  },
);

export const submitResignationApplication = (values) => contractHttpRequest.post(
  RESIGNATION_API_PATHS.create,
  buildResignationApplicationPayload(values),
);

export const getResignationApplicationPage = fetchResignationApplications;
export const createResignationApplication = submitResignationApplication;

export default {
  RESIGNATION_API_PATHS,
  fetchH5ResignationConfig,
  buildResignationApplicationPayload,
  fetchResignationApplications,
  submitResignationApplication,
  getResignationApplicationPage,
  createResignationApplication,
};
